import {
	Dispatch,
	FC,
	PropsWithChildren,
	SetStateAction,
	createContext,
	useEffect,
	useState,
} from 'react';

import { IDateRange } from '@/shared/types/app.types';
import { IBookingObjects } from '@/shared/types/bookingObjects.types';

import { getPermission } from '@/configs/serviceworker-registration.ts';

type BookContextType = {
	bookingPlace: IBookingObjects | null;
	currentDate: IDateRange | null;
	currentBookingLoad: number | null;
	setBookingPlace: Dispatch<SetStateAction<BookContextType['bookingPlace']>>;
	setCurrentDate: Dispatch<SetStateAction<BookContextType['currentDate']>>;
	setCurrentBookingLoad: Dispatch<SetStateAction<BookContextType['currentBookingLoad']>>;
};

export const BookContext = createContext<BookContextType>({} as BookContextType);

export const BookContextProvider: FC<PropsWithChildren> = ({ children }) => {
	const [currentPlace, setCurrentPlace] = useState<BookContextType['bookingPlace']>(null);
	const [currentDate, setCurrentDate] = useState<BookContextType['currentDate']>(null);
	const [currentBookingLoad, setCurrentBookingLoad] =
		useState<BookContextType['currentBookingLoad']>(null);

	useEffect(() => {
		void getPermission();
	}, []);

	return (
		<BookContext.Provider
			value={{
				bookingPlace: currentPlace,
				currentDate,
				currentBookingLoad,
				setBookingPlace: setCurrentPlace,
				setCurrentDate,
				setCurrentBookingLoad,
			}}
		>
			{children}
		</BookContext.Provider>
	);
};
